import { render, staticRenderFns } from "./LogImagesPicker.vue?vue&type=template&id=5c98a7b2&scoped=true&"
import script from "./LogImagesPicker.vue?vue&type=script&lang=js&"
export * from "./LogImagesPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98a7b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c98a7b2')) {
      api.createRecord('5c98a7b2', component.options)
    } else {
      api.reload('5c98a7b2', component.options)
    }
    module.hot.accept("./LogImagesPicker.vue?vue&type=template&id=5c98a7b2&scoped=true&", function () {
      api.rerender('5c98a7b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/LogImagesPicker.vue"
export default component.exports